// Google Ads conversion tracking utility
// Compatible avec notre chargement conditionnel RGPD : si gtag n'est pas chargé
// (utilisateur n'a pas accepté les cookies), la fonction fait un simple no-op
// puis exécute le callback (ex: redirection) immédiatement.

const AW_ID = 'AW-586557208';

/**
 * Envoie un événement de conversion Google Ads puis exécute le callback.
 * Si gtag n'est pas chargé (consentement refusé), le callback est appelé immédiatement.
 *
 * @param {string} sendTo - Format "AW-XXXXXXXXX/LABEL" (identifiant de conversion)
 * @param {object} opts - { value, currency, transactionId }
 * @param {Function} [callback] - À exécuter après l'envoi (ou immédiatement si gtag absent)
 */
export function reportConversion(sendTo, opts = {}, callback) {
  const { value, currency = 'EUR', transactionId = '' } = opts;

  // Fallback si gtag n'est pas disponible : exécuter directement le callback
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    if (typeof callback === 'function') callback();
    return false;
  }

  // Sécurité : forcer le callback au bout de 2s si Google ne répond pas
  let done = false;
  const safeCallback = () => {
    if (done) return;
    done = true;
    if (typeof callback === 'function') callback();
  };
  setTimeout(safeCallback, 2000);

  window.gtag('event', 'conversion', {
    send_to: sendTo,
    value: value,
    currency: currency,
    transaction_id: transactionId,
    event_callback: safeCallback,
  });

  return false;
}

// Export de l'ID principal pour commodité
export { AW_ID };
